<template>
  <div>
    <div class="menu" ref="menu">
      <Menu :bus="bus"/>
    </div>
    <div class="gray_area">
      <div class="container">
         <div class="row logo__row">          
          <div class="col-sm-12 text-sm-center mt-2 mb-2">
            <img v-bind:src="require('@/assets/img/logo_wfg.png')" />
          </div>
        </div>

        <div class="row about__row menu__target">
          <div class="col-sm-6 mt-2 mb-2 ">
            <Title v-bind:title="$t('home.about.title')" />
            <p v-html="$t('home.about.text')" />
          </div>
          <div class="col-sm-6 mt-2 mb-2">
            <img v-bind:src="require('@/assets/img/grafica-soci.jpg')" />
          </div>
        </div>

        <div class="row structure__row menu__target">
          <div class="col-sm-5 text-center mt-2 mb-2">
            <img v-bind:src="require('@/assets/img/struttura.jpg')" />
          </div>
          <div class="col-sm-6 mt-2 mt-md-5 mb-2">
            <Title v-bind:title="$t('home.struttura.title')" />
            <div class="d-flex flex-wrap justify-content-center">
              <span class="structure__logo my-3"><a target="_blank" rel="noopener nofollow" href="http://www.weg.it"><img v-bind:src="require('@/assets/img/struttura_logo/logo_wfg.svg')" /></a></span>
              <span class="structure__logo my-3"><a target="_blank" rel="noopener nofollow" href="http://www.fr-evolution.com/"><img v-bind:src="require('@/assets/img/struttura_logo/logo_rev.png')" /></a></span>
              <span class="structure__logo my-3"><a target="_blank" rel="noopener nofollow" href="http://www.bycreations.com/"><img v-bind:src="require('@/assets/img/struttura_logo/logo_creation.png')" /></a></span>
              <span class="structure__logo my-3"><a target="_blank" rel="noopener nofollow" href="https://iscoming.es/"><img v-bind:src="require('@/assets/img/struttura_logo/logo_iscoming.svg')" /></a></span>

            </div>
          </div>
        </div>

        <div class="row history__row ">
          <div class="col-sm-12 text-sm-center">
            <Title v-bind:title="$t('home.storia.title')" />
          </div>

          <div class="history__item col-sm-12 menu__target">
            <Timeline 
              :bus="bus"
              :year="$t('home.storia.seventies.year')"
              :year_before="$t('home.storia.overtitle_year')"
              :text="$t('home.storia.seventies.text')"
              :isInvert="true"
              :images="[require(`@/assets/img/storia/_70/foto 1.jpg`), require(`@/assets/img/storia/_70/foto 2.jpg`), require(`@/assets/img/storia/_70/foto 3.jpg`)]"
            />
          </div>

          <div class="history__item col-sm-12 menu__target">
            <Timeline 
              :bus="bus"
              :year="$t('home.storia.eighties.year')"
              :year_before="$t('home.storia.overtitle_year')"
              :text="$t('home.storia.eighties.text')"
              :isInvert="false"
              :images="[require(`@/assets/img/storia/_80/foto 1.jpg`),
                 require(`@/assets/img/storia/_80/foto 2.jpg`),
                 require(`@/assets/img/storia/_80/foto 3.jpg`),
                 require(`@/assets/img/storia/_80/foto 4.jpg`),
                 require(`@/assets/img/storia/_80/foto 5.jpg`) ]"
            />
          </div>

          <div class="history__item col-sm-12 menu__target">
            <Timeline 
              :bus="bus"
              :year="$t('home.storia.nineties.year')"
              :year_before="$t('home.storia.overtitle_year')"
              :text="$t('home.storia.nineties.text')"
              :isInvert="true"
              :images="[require(`@/assets/img/storia/_90/foto 1.jpg`),
                require(`@/assets/img/storia/_90/foto 2.jpg`),
                require(`@/assets/img/storia/_90/foto 3.jpg`),
                require(`@/assets/img/storia/_90/foto 4.jpg`),
                require(`@/assets/img/storia/_90/foto 5.jpg`),
                require(`@/assets/img/storia/_90/foto 6.jpg`)]"
            />
          </div>    

          <div class="history__item col-sm-12 menu__target">
            <Timeline 
              :bus="bus"
              :year="$t('home.storia.oo.year')"
              :year_before="$t('home.storia.overtitle_year')"
              :text="$t('home.storia.oo.text')"
              :isInvert="false"
              :images="[require(`@/assets/img/storia/_00/foto 1.jpg`),
                require(`@/assets/img/storia/_00/foto 2.jpg`),
                require(`@/assets/img/storia/_00/foto 3.jpg`),
                require(`@/assets/img/storia/_00/foto 4.jpg`),
                require(`@/assets/img/storia/_00/foto 5.jpg`),
                require(`@/assets/img/storia/_00/foto 6.jpg`),
                require(`@/assets/img/storia/_00/foto 7.jpg`)]"
            />
          </div>

          <div class="history__item col-sm-12 menu__target">
            <Timeline 
              :bus="bus"
              :year="$t('home.storia.ten.year')"
              :year_before="$t('home.storia.overtitle_year')"
              :text="$t('home.storia.ten.text')"
              :isInvert="true"
              :images="[require(`@/assets/img/storia/_10/foto 1.jpg`),
                require(`@/assets/img/storia/_10/foto 2.jpg`),
                require(`@/assets/img/storia/_10/foto 3.jpg`),
                require(`@/assets/img/storia/_10/foto 6.jpg`),
                require(`@/assets/img/storia/_10/foto 7.jpg`),
                require(`@/assets/img/storia/_10/foto 8.jpg`),
                require(`@/assets/img/storia/_10/foto 9.jpg`),
                require(`@/assets/img/storia/_10/foto 10.jpg`),
                require(`@/assets/img/storia/_10/foto 11.jpg`),
                require(`@/assets/img/storia/_10/foto 12.jpg`),
                require(`@/assets/img/storia/_10/foto 13.jpg`),
                require(`@/assets/img/storia/_10/foto 14.jpg`)]"
            />
          </div>

          <div class="history__item col-sm-12 menu__target">
            <Timeline 
              :bus="bus"
              :year="$t('home.storia.twenty.year')"
              :year_before="$t('home.storia.overtitle_year')"
              :text="$t('home.storia.twenty.text')"
              :images="[require(`@/assets/img/storia/_20/anni-20.jpg`)]"
            />
          </div>
        </div>


      </div>
      
    </div>
    <div class="white_area contact__container">

      <div class="container">
        <div class="row contact__row menu__target">
          <div class="col-sm-12 text-center">
            <Title v-bind:title="$t('home.contact.title')" />
          </div>
          <div class="mt-4 col-sm-5 contact__info text-center offset-sm-1 d-flex flex-column">
            <div>
              <img width="80" v-bind:src="require('@/assets/img/logo_wfg.png')" /><br>
              <p>Weg fashion group</p>
            </div>
            <div>
              <img v-bind:src="require('@/assets/img/contact_icons/pin.svg')" /><br>
              <p><a href="" target="_blank" rel="noopener nofollow">Via Campania, 3<br>
                41012 Carpi (Modena) Italy</a></p>
            </div>
            <div>
              <img v-bind:src="require('@/assets/img/contact_icons/phone.svg')" /><br>
              <p><a href="tel:0599120411">059.9120411</a></p>
            </div>
            <div>
              <img v-bind:src="require('@/assets/img/contact_icons/mail.svg')" /><br>
              <p><a href="mailto:info@wegfashiongroup.com">info@wegfashiongroup.com</a></p>
            </div>
            <div>
              <p> <a
                  :href="'//www.iubenda.com/privacy-policy/' + $t('iubendaid')"
                  target="_blank" rel="noopener"
                  class="iubenda-nostyle no-brand"
                  title="Privacy Policy"
                >Privacy policy</a>
              </p>
            </div>
          </div>
          <div class="mt-4 col-sm-4 d-flex flex-column">
            <MainForm />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Vue from "vue";

import Title from '@/components/Title'
import Timeline from '@/components/Timeline'
import Menu from '@/components/Menu'
import MainForm from '@/components/form/MainForm'

export default {
  name: "home",
  data() {
    return {
      bus: new Vue()
    };
  },
  components: {
    Title,
    Timeline,
    MainForm,
    Menu
  },
  mounted() {

    this.$nextTick(() => {
      (function(w, d) {
        var loader = function() {
          var s = d.createElement("script"),
            tag = d.getElementsByTagName("script")[0];
          s.src = "//cdn.iubenda.com/iubenda.js";
          tag.parentNode.insertBefore(s, tag);
        };
        if (w.addEventListener) {
          w.addEventListener("load", loader, false);
        } else if (w.attachEvent) {
          w.attachEvent("onload", loader);
        } else {
          w.onload = loader;
        }
      })(window, document);

    });
  }
};
</script>


<style lang="scss">
  .gray_area {
    background-color: $medium-gray;
    color: white;
    overflow: hidden;
  }
  .logo__row {
    padding-top: 30px;
    @include media-breakpoint-up(md) {
      padding-bottom: 30px;
    }
    @include media-breakpoint-up(lg) {
      padding-bottom: 80px;
    }
  }
  .structure__row,
  .history__row,
  .about__row {
    padding-top: 50px;
    padding-bottom: 25px;
    @include media-breakpoint-up(md) {
      padding-top: 150px;
      padding-bottom: 75px;
    }
  }
  .about__row {
    @include media-breakpoint-up(md) {
      padding-top: 40px;
    }
  }
  .structure__logo {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 20px;
    margin-right: 20px;
    a {
      display: block;
    }
  }

  .history__item {
    margin-bottom: 50px;
    margin-top: 50px;
    @include media-breakpoint-up(lg) {
      margin-bottom: 100px;
      margin-top: 100px;
    }
  }

  .white_area {
    padding-top: 60px;
    @include media-breakpoint-up(lg) {
      padding-top: 100px;
      padding-bottom: 100px;
    }
  }

  .contact__container {
    @include media-breakpoint-up(lg) {
      background: transparent url('~@/assets/img/manichino.jpg') no-repeat 7% bottom / 210px;
    }
    @include media-breakpoint-only(lg) {
      background-position: 2% bottom;
      background-size: 160px;
    }
  }
  .contact__info {
    &, a {
      color: #a3a3a3;
    }
    img {
      margin-bottom: 10px;
    }
    > div {
      margin-bottom: 46px
    }
  }
</style>
